// extracted by mini-css-extract-plugin
module.exports = {"example__text":"ProjectSaveView_example__text__1_vKd","main__view":"ProjectSaveView_main__view__1bBNo","triangleCover":"ProjectSaveView_triangleCover__1rKCt"};